/**
 * Content CP (Content Commonplace) Page - Main entry point for the /content_cp route
 *
 * Chat + Cards interface for knowledge management with card ingestion.
 */

import { ContentCpView } from './ContentCpView'

export function ContentCpPage() {
  return <ContentCpView />
}
